import { GridItem } from '@bnnvara/grids';
import { Heading } from '@bnnvara/typography';
import flowRight from 'lodash/flowRight';
import get from 'lodash/get';
import PropTypes from 'prop-types';
/* eslint-disable no-underscore-dangle */
import React from 'react';

import createUrl from '../../../helpers/createUrl';
import resizeImageSource from '../../../helpers/resizeImageSource';
import RecommendedItem from '../RecommendedItem';

const formatResultItem = (result) => ({
  ...result,
  brand: (result.brand && result.brand.name) || result.brandName || 'NO BRAND',
  tags: Array.isArray(result.tags) ? result.tags : [],
  imageUrl: resizeImageSource(get(result, 'thumbnail.url', null)) || null,
  index: result.index,
  uri: createUrl(
    (result.brand && result.brand.slug) || result.brandName,
    result.mediaType || result.__typename,
    result.slug || result.id
  ),
});

const FormattedRecommendedItem = flowRight(RecommendedItem, formatResultItem);

const RecommendationBlock = ({ results, title, recomType }) => {
  const renderContent = results && results.length > 0;

  return (
    <React.Fragment>
      <GridItem
        columnStartSm="1"
        columnEndSm="span 12"
        columnStartMd="1"
        columnEndMd="span 10"
        columnStartLg="1"
        columnEndLg="11"
      >
        {renderContent && (
          <Heading element="h2" variant="one">
            {title}
          </Heading>
        )}
      </GridItem>
      {results &&
        results.map((item, index) => (
          <FormattedRecommendedItem
            key={item.id}
            index={index}
            {...item}
            recomType={recomType}
          />
        ))}
    </React.Fragment>
  );
};

RecommendationBlock.propTypes = {
  results: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string.isRequired,
  recomType: PropTypes.string.isRequired,
};

export default RecommendationBlock;
